/**
 * 浏览器通知权限管理工具
 */

// 检查浏览器是否支持通知
export const isBrowserNotificationSupported = (): boolean => {
  return "Notification" in window;
};

// 获取当前通知权限状态
export const getNotificationPermission = (): NotificationPermission => {
  if (!isBrowserNotificationSupported()) {
    return "denied";
  }
  return Notification.permission;
};

// 检查是否是 Chrome 浏览器
export const isChromeBrowser = (): boolean => {
  const userAgent = navigator.userAgent.toLowerCase();
  return /chrome/.test(userAgent) && !/edge|edg|opr|brave/.test(userAgent);
};

// 请求通知权限
export const requestNotificationPermission = async (): Promise<NotificationPermission> => {
  if (!isBrowserNotificationSupported()) {
    return "denied";
  }

  try {
    const permission = await Notification.requestPermission();
    return permission;
  } catch (error) {
    console.error("Failed to request notification permission:", error);
    return "denied";
  }
};

// 发送浏览器通知
export const sendBrowserNotification = (title: string, options?: NotificationOptions): Notification | null => {
  if (!isBrowserNotificationSupported() || Notification.permission !== "granted") {
    return null;
  }

  try {
    const notification = new Notification(title, {
      icon: "https://staticjs.kaloclip.com/sources/images/favicon.png",
      badge: "https://staticjs.kaloclip.com/sources/images/favicon.png",
      // 保持通知直到用户关闭，便于在 Mac 上看到（部分浏览器支持）
      requireInteraction: true,
      ...options,
    });
    return notification;
  } catch (error) {
    console.error("Failed to send notification:", error);
    return null;
  }
};

// 检查是否需要显示权限引导（Chrome 浏览器且未授权）
export const shouldShowNotificationGuide = (): boolean => {
  const permission = getNotificationPermission();
  // 仅在 Chrome 浏览器且权限为 default（未决定）或 denied 时显示引导
  return isChromeBrowser() && (permission === "default" || permission === "denied");
};
